module.exports = __webpack_public_path__ + "static/media/rw.6c326d8e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/rw.png
// module id = 1970
// module chunks = 0